import FicheModal from '@components/fiche/modal';
import StickyHeader from '@components/header/header';
import Carousel from '@components/news/carousel';
import FicheFilter from '@components/fiche/filter';
import Gallery from '@components/gallery/gallery';
import EventFilter from '@components/news/filter';
import FullDayEvents from "@components/news/fullDayEvents";
import Jumbotron from '@components/jumbotron/jumbotron';
import Newsletter from '@components/newsletter/newsletter';
import jQuery from 'jquery';

(function ($) {
    new StickyHeader();
    new FicheModal();
    new Carousel('#events-carousel');
    new Carousel('#news-carousel');
    new FicheFilter('.fiche-container');
    new EventFilter('.all-events');
    new Gallery('.gallery-wrapper', '.gallery-wrapper-navigation');
    new Jumbotron();
    new Newsletter();
    new FullDayEvents();
})(jQuery);


jQuery(document).ready(function($) {
    console.log("Hello world2")
	if ($('form').length) {
		$('form').each((key, item) => {
		    const btn = $(item).find('[type="submit"]');
			// on submit form, disable submit button
			/*$(item).on('submit', function() {
				btn.attr('disabled', true);
                setTimeout(() => {
                    btn.attr('disabled', false);
                }, 4000);
			})*/
		})
	}
});
